import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { handleCopyToClipboard } from "@/utils/helpers";
import { Copy } from "lucide-react";

interface ApplicationReferenceButtonProps {
  userApplicationId: string;
}

const ApplicationReferenceButton: React.FC<ApplicationReferenceButtonProps> = ({ userApplicationId }) => {
  return (
    <div className="flex flex-col justify-between">
      <h4 className="pb-1 font-inter text-xs font-normal text-gray-800">Application Reference No.</h4>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant={"secondary"}
              className="group flex w-full flex-row justify-between bg-white"
              onClick={() => handleCopyToClipboard(userApplicationId)}
            >
              <span className={cn("text-sm font-bold leading-[20px] text-gray-900", "font-menlo")}>{userApplicationId}</span>
              <span className="ml-2 h-4 w-4 font-bold text-gray-900 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                <Copy className="h-4 w-4" />
              </span>
            </Button>
          </TooltipTrigger>
          <TooltipContent side={"bottom"} className="z-9999">
            Copy to clipboard
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default ApplicationReferenceButton;
